export default "__VITE_ASSET__f4f593ce__"